import { useState } from "react";
import {
  RequestUpsertShippingSourceInformationRequest,
  ShippingSourceInformationApi,
  ShippingSourceInformationUpsertShippingSourceInformationPostRequest,
} from "../../services/OpenAPI";
import { createConfiguration } from "./common";

export const useApiUpsertShippingSourceInformation = () => {
  const [result, setResult] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const upsertShippingSourceInformation = async (
    req: RequestUpsertShippingSourceInformationRequest
  ) => {
    setIsLoading(true);
    setError(null);

    try {
      setIsLoading(true);
      const config = createConfiguration();
      const request: ShippingSourceInformationUpsertShippingSourceInformationPostRequest =
        {
          req,
        };

      const api = new ShippingSourceInformationApi(config);
      const response =
        await api.shippingSourceInformationUpsertShippingSourceInformationPost(
          request
        );
      setResult(response);
      return response;
    } catch (err) {
      setError("配送元情報の更新に失敗しました");
      console.error(err);
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return { upsertShippingSourceInformation, error, isLoading };
};
